// Import all your components here
// But don't code inside this file.
// camelCase your file name

// Utilities first so you can use it through all your other files
// import './utils/polyfills'; // Only if IE 11 & Edge 15
import './utils/utils';

// Global files next, to use everywhere. Potentially needing utilities.
// Don't forget all the dependencies needed by your framework.
// Foundation needs jQuery & what-input to work.
import $ from 'jquery';
import 'what-input';

// Foundation 6.7.4
import './global/foundation';
$(document).foundation();

// Components
import './components/reveal';
import './components/fixedHeader';
import './components/facetwp';
import './components/gravityForm';
import './components/lazyLoad';
import './components/loadPosts';
import './components/singleProduct';
// import './components/masonry';
import './components/mobileMenu';
import './components/photoswipe';
// import './components/searchbar';
import './components/socialSharerToggle';
import './components/smoothScroll';
import {initTooltips} from './components/tooltip';
import './components/toggler';
import './components/equipments';
import './components/tabs';
import './components/dropdown';
import './components/vivafi';
import './components/scrollToTop';
import './components/alerts';
import './components/google-reviews';
import {initSwiperProductCards, initSwiperMobile, initSwiperProduct, initSwiperRelatedProducts, initSwiperAdCards, initOffersSwiper} from './components/swiper';
initTooltips();
initSwiperProductCards();
initSwiperMobile();
initSwiperProduct();
initSwiperRelatedProducts();
initSwiperAdCards();
initOffersSwiper();

// Enables HMR for JS files imported here
if (module.hot)
  module.hot.accept();

// Signed by Choosit!
console.log(`%cMade with ❤️ by Choosit!`, `color: #009ee0;`);
